import { URL_CONSTANTS } from '../constants/urlConstants';
import {
  REACT_APP_GMAPS_KEY,
  REACT_APP_CUBE_BASEURL,
  REACT_APP_CUBEJS_BETA_BASE_URL,
} from '../constants/envConstants';

export const authURL = URL_CONSTANTS.LOGIN.baseUrl;
export const googleMapsKey = REACT_APP_GMAPS_KEY;
export const CUBEJS_BASE_URL = REACT_APP_CUBE_BASEURL;
export const CUBEJS_BETA_BASE_URL = REACT_APP_CUBEJS_BETA_BASE_URL;
